import React from 'react';

import { Layout } from 'antd';

import footerLogo from '@assets/images/yourCentinelFooter.png';

export const LandingFooter: React.FC = (): React.ReactElement => {
  return (
    <Layout.Footer className="w-full h-[236px] text-center static bottom-0 bg-lightBlue p-0 pt-7">
      <img
        src={footerLogo}
        alt="YourCentinel logo"
        className="max-h-[170px] h-full max-w-[470px] w-full"
      />
    </Layout.Footer>
  );
};
